import { useCreateDualScopeType, useDualScopeTypes } from '@/hooks/useDualScopeTypes';
import type { EndOfLifePlan } from '@/types/assets';

/**
 * Fetch end-of-life plans (global + organization-specific).
 * Thin wrapper around useDualScopeTypes — see docs/DUAL_SCOPE_TYPES.md.
 */
export const useEndOfLifePlans = (
  organizationId?: string,
  options?: {
    enabled?: boolean;
    activeOnly?: boolean;
  }
) => useDualScopeTypes<EndOfLifePlan>('end_of_life_plans', organizationId, options);

/**
 * Create an organization-specific end-of-life plan. Used by the inline
 * `_create:<name>` flow in the materials grid.
 */
export const useCreateEndOfLifePlan = () =>
  useCreateDualScopeType('end_of_life_plans');

export const getEndOfLifePlanById = (
  plans: EndOfLifePlan[] | undefined,
  id: string | undefined
): EndOfLifePlan | undefined => {
  if (!plans || !id) return undefined;
  return plans.find((p) => p.id === id || p.code === id);
};

/**
 * Check if end-of-life plan requires waste treatment method
 */
export const requiresWasteMethod = (
  plans: EndOfLifePlan[] | undefined,
  planId: string | undefined
): boolean => {
  const plan = getEndOfLifePlanById(plans, planId);
  return plan?.requires_waste_method ?? false;
};
